import type { ReactNode } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';

import { StyledSearchRefinementsWrapperForm } from './SearchRefinementsWrapper.styled';

type Props = {
  sticky: boolean;
  hideOnMobile: boolean;
  children: ReactNode;
};

/**
 * This component is outside <SearchRefinements /> because currently we lazy-load
 * the refinements.
 */
export function SearchRefinementsWrapper({
  sticky,
  hideOnMobile,
  children,
}: Props) {
  const { locale } = useI18n();

  return (
    <StyledSearchRefinementsWrapperForm
      id={sticky ? 'sticky-search-refinements' : undefined}
      data-qa-id="search-refinements"
      $locale={locale}
      // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
      role="search"
      data-hide-on-mobile={hideOnMobile ? true : undefined}
      onSubmit={(e) => e.preventDefault()}
    >
      {children}
    </StyledSearchRefinementsWrapperForm>
  );
}
